
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class SupportGrid extends Serenity.EntityGrid<SupportRow, any> {
        protected getColumnsKey() { return SupportColumns.columnsKey; }
        protected getDialogType() { return SupportDialog; }
        protected getIdProperty() { return SupportRow.idProperty; }
        protected getInsertPermission() { return SupportRow.insertPermission; }
        protected getLocalTextPrefix() { return SupportRow.localTextPrefix; }
        protected getService() { return SupportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[]
        {
            var buttons = super.getButtons();

            // here is several methods to remove add button
            if (!Authorization.hasPermission("Administration:Security") && Authorization.hasPermission("Users:Support")) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            return buttons;
        }
    }
}